import RandomPlanet from './Random-planet';

export default RandomPlanet;